import { render } from "./Bank.vue?vue&type=template&id=17f465c6&scoped=true"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"

import "./Bank.vue?vue&type=style&index=0&id=17f465c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f465c6"]])

export default __exports__